/**
 * defa.collections.digiHeat
 * A Collection of DigiHeat
 * @version 1.2.0
 */
import DigiHeat from './model-digiheat';

const DigiHeats = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : DigiHeat,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default DigiHeats;